import React from 'react';
import styled from 'styled-components';

import { keys } from '../../../util/lodashlike';
// FIN-12133: getActionColor(action) resolves the action's configured severity's
// level colour (action_severity -> alert_level_details). Supplied by the caller
// (which has the alert-level configs); falls back to the legacy field if absent.
const AlertsLevelFraudComponent = ({
  actionCount,
  actionList,
  getActionColor
}) => {
  return (
    <StyledDiv>
      {keys(actionCount).map((key) => {
        const actionType = actionList.find(
          ({ displayName }) => displayName?.toLowerCase() === key?.toLowerCase()
        );
        const color = getActionColor
          ? getActionColor(key)
          : actionType?.alertLevelColor;

        return (
          <div key={key} style={{ color }}>
            {key}: {actionCount[key]}
          </div>
        );
      })}
    </StyledDiv>
  );
};

const StyledDiv = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 11px;
  font-weight: 500;
  flex-wrap: wrap;
  gap: 12px;
`;

export default AlertsLevelFraudComponent;
